import styled from 'styled-components';

const NavbarElement = styled.button`
  font-size: ${({ theme: { fontSizes } }) => `${fontSizes[3]}px`};
  position: relative;
  border: none;
  background: none;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-duration: 400ms;
  transition-property: color;
  padding-left: ${({ theme: { space } }) => `${space[2]}px`};
  padding-right: ${({ theme: { space } }) => `${space[2]}px`};
  margin-left: ${({ theme: { space } }) => `${space[3]}px`};
  margin-right: ${({ theme: { space } }) => `${space[3]}px`};

  &:hover:after {
    width: 100%;
    left: 0%;
  }

  &:after {
    content: '';
    pointer-events: none;
    bottom: -2px;
    left: 50%;
    position: absolute;
    width: 0%;
    height: 2px;
    background-color: ${({ theme: { colors } }) => colors.text};
    transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
    transition-duration: 400ms;
    transition-property: width, left;
  }
`;

export default NavbarElement;
